
// ── Shopify Checkout ──
// Stores variant info: { '1': {id, qty}, '2': {id, qty}, '5': {id, qty} }
// If pack variants exist (2-Pack, 5-Pack), each adds qty=1 of that variant.
// If only one variant exists, falls back to adding the right quantity.
window.tbReady = false;
window.tbTiers = {};
window.totalBottleVariantId = null;

(function() {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/products/total-bottle.js', true);
  xhr.onload = function() {
    if (xhr.status < 200 || xhr.status >= 300) return;
    try {
      var p = JSON.parse(xhr.responseText);
      if (!p.variants || !p.variants.length) return;

      window.totalBottleVariantId = p.variants[0].id;
      var hasMultiple = p.variants.length > 1;

      if (hasMultiple) {
        // Map variants by name — look for "2" or "5" in title
        p.variants.forEach(function(v) {
          var t = v.title.toLowerCase();
          if (t.indexOf('5') !== -1 || t.indexOf('five') !== -1) {
            window.tbTiers['5'] = { id: v.id, qty: 1 };
          } else if (t.indexOf('2') !== -1 || t.indexOf('two') !== -1) {
            window.tbTiers['2'] = { id: v.id, qty: 1 };
          } else {
            window.tbTiers['1'] = { id: v.id, qty: 1 };
          }
        });
      }

      // Fallback: if any tier is missing, use default variant with correct quantity
      var def = p.variants[0].id;
      if (!window.tbTiers['1']) window.tbTiers['1'] = { id: def, qty: 1 };
      if (!window.tbTiers['2']) window.tbTiers['2'] = { id: def, qty: 2 };
      if (!window.tbTiers['5']) window.tbTiers['5'] = { id: def, qty: 5 };

      window.tbReady = true;
    } catch(e) {}
  };
  xhr.send();
})();

function buyTotalBottle() {
  if (window.location.protocol === 'file:' || window.location.hostname === 'localhost') {
    window.location = 'https://totalbottle.com/products/total-bottle';
    return;
  }
  // Just go to product page — let user pick a tier there
  window.location = '/products/total-bottle';
}

// ── Add to Cart (pricing tiers on homepage) ──
function addToCart(tier) {
  // Preview fallback
  if (window.location.protocol === 'file:' || window.location.hostname === 'localhost') {
    window.location = 'https://totalbottle.com/products/total-bottle';
    return;
  }

  var tierStr = String(tier);
  var info = window.tbTiers[tierStr];

  // If product data hasn't loaded yet, go to product page
  if (!info || !window.tbReady) {
    window.location = '/products/total-bottle';
    return;
  }

  // Disable all tier buttons and show loading state
  var btns = document.querySelectorAll('.tier-btn');
  var clickedBtn = null;
  btns.forEach(function(b) {
    b.disabled = true;
    b.style.opacity = '0.6';
    if (b.getAttribute('onclick') && b.getAttribute('onclick').indexOf(tierStr) !== -1) {
      clickedBtn = b;
    }
  });
  if (clickedBtn) clickedBtn.innerHTML = 'Adding to cart...';

  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = function() {
    if (xhr.status >= 200 && xhr.status < 300) {
      if (clickedBtn) clickedBtn.innerHTML = 'Added! Redirecting...';
      window.location = '/cart';
    } else {
      // Re-enable buttons on error
      btns.forEach(function(b) { b.disabled = false; b.style.opacity = '1'; });
      if (clickedBtn) clickedBtn.innerHTML = 'Error — Try Again';
      // Try to show what went wrong
      try {
        var err = JSON.parse(xhr.responseText);
        alert('Could not add to cart: ' + (err.description || err.message || 'Unknown error'));
      } catch(e) {
        alert('Could not add to cart. Status: ' + xhr.status);
      }
    }
  };
  xhr.onerror = function() {
    btns.forEach(function(b) { b.disabled = false; b.style.opacity = '1'; });
    alert('Network error. Please check your connection.');
  };
  xhr.send(JSON.stringify({ items: [{ id: info.id, quantity: info.qty }] }));
}

// ── Replacement Parts ──
// Variant IDs are rendered by Liquid directly into data-variant-id attributes
function addPart(btn) {
  // Preview fallback
  if (window.location.protocol === 'file:' || window.location.hostname === 'localhost') {
    alert('Parts ordering available on the live site.');
    return;
  }

  var variantId = btn.getAttribute('data-variant-id');

  if (!variantId || variantId.trim() === '') {
    alert('This part is not yet available. Please contact hello@totalbottle.com');
    return;
  }

  variantId = parseInt(variantId);
  btn.disabled = true;
  btn.textContent = 'Adding...';

  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = function() {
    if (xhr.status >= 200 && xhr.status < 300) {
      btn.textContent = 'Added!';
      setTimeout(function() { window.location = '/cart'; }, 400);
    } else {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
      try {
        var err = JSON.parse(xhr.responseText);
        alert('Error: ' + (err.description || err.message || 'Could not add to cart'));
      } catch(e) {
        alert('Could not add to cart. Status: ' + xhr.status);
      }
    }
  };
  xhr.onerror = function() {
    btn.disabled = false;
    btn.textContent = 'Add to Cart';
    alert('Network error. Please check your connection.');
  };
  xhr.send(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }));
}

// ── FAQ Toggle ──
function toggleFaq(el) {
  const isOpen = el.classList.contains('open');
  // Close all FAQs first
  document.querySelectorAll('.faq-item.open').forEach(item => item.classList.remove('open'));
  // Toggle the clicked one
  if (!isOpen) el.classList.add('open');
}

// ── Impact Store Slider ──
(function() {
  const sliderProducts = [
    { name: "Bamboo Toothbrush", points: 90, img: "{{ 'img-014-29548f51.jpg' | asset_url }}" },
    { name: "Reusable Stainless Steel Straw Set", points: 100, img: "{{ 'img-015-29548f51.jpg' | asset_url }}" },
    { name: "Reusable Coffee Filter", points: 130, img: "{{ 'img-016-02f7ef69.jpg' | asset_url }}" },
    { name: "LED Light Bulbs", points: 130, img: "{{ 'img-017-02f7ef69.jpg' | asset_url }}" },
    { name: "Reusable Produce Bags", points: 150, img: "{{ 'img-018-02f7ef69.jpg' | asset_url }}" },
    { name: "Reusable Makeup Remover Pads", points: 150, img: "{{ 'img-019-02f7ef69.jpg' | asset_url }}" },
    { name: "Wool Dryer Balls", points: 170, img: "{{ 'img-020-29548f51.jpg' | asset_url }}" },
    { name: "Refillable Deodorant", points: 190, img: "{{ 'img-021-29548f51.jpg' | asset_url }}" },
    { name: "Shampoo & Conditioner Bars", points: 230, img: "{{ 'img-022-02f7ef69.jpg' | asset_url }}" },
    { name: "Safety Razor", points: 350, img: "{{ 'img-023-29548f51.jpg' | asset_url }}" },
    { name: "Total Bottle", points: 800, img: "{{ 'img-024-02f7ef69.jpg' | asset_url }}" },
    { name: "Hydro Holster", points: 3000, img: "{{ 'img-025-ddbe594c.jpg' | asset_url }}" },
    { name: "Siesta 4", points: 4500, img: "{{ 'img-026-ddbe594c.jpg' | asset_url }}" }
  ];

  const slider = document.getElementById('storeSlider');
  if (!slider) return;

  // Duplicate for seamless infinite scroll
  const allItems = [...sliderProducts, ...sliderProducts];
  slider.innerHTML = allItems.map(p => `
    <a href="/store.html" class="slider-card">
      <div class="slider-card-img"><img src="${p.img}" alt="${p.name}" loading="lazy"></div>
      <div class="slider-card-info">
        <div class="slider-card-name">${p.name}</div>
        <div class="slider-card-bottom">
          
          <span class="slider-card-pts"><span class="slider-card-pts-dot">P</span>${p.points.toLocaleString()}</span>
        </div>
      </div>
    </a>
  `).join('');
})();

// ── Hero Image Crossfader ──
(function() {
  try {
    var heroSlides = [
      { imgId: 'hImg0', label: 'The Complete System' },
      { imgId: 'hImg1', label: 'Everything Included' }
    ];
    var hIdx = 0;
    var hTimer = null;
    var hPills = document.querySelectorAll('.slide-pill');
    var hLabel = document.getElementById('slideLabel');

    function goHeroSlide(idx) {
      if (idx === hIdx) return;
      var prevImg = document.getElementById(heroSlides[hIdx].imgId);
      var nextImg = document.getElementById(heroSlides[idx].imgId);
      if (!prevImg || !nextImg) return;

      prevImg.classList.remove('active');
      prevImg.classList.add('exiting');

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          nextImg.classList.add('active');
        });
      });

      setTimeout(function() { prevImg.classList.remove('exiting'); }, 2500);

      hIdx = idx;

      if (hLabel) {
        hLabel.style.opacity = '0';
        setTimeout(function() {
          hLabel.textContent = heroSlides[hIdx].label;
          hLabel.style.opacity = '1';
        }, 600);
      }

      hPills.forEach(function(p, i) {
        p.classList.toggle('active', i === hIdx);
        var prog = p.querySelector('.slide-pill-progress');
        if (prog) {
          prog.style.animation = 'none';
          void prog.offsetHeight;
          if (i === hIdx) prog.style.animation = 'fillPill 3s linear forwards';
        }
      });

      clearTimeout(hTimer);
      hTimer = setTimeout(function() { goHeroSlide((hIdx + 1) % heroSlides.length); }, 3000);
    }

    hPills.forEach(function(p) { p.addEventListener('click', function() { goHeroSlide(+p.dataset.idx); }); });
    if (hPills.length > 0) {
      setTimeout(function() {
        var prog = hPills[0].querySelector('.slide-pill-progress');
        if (prog) prog.style.animation = 'fillPill 3s linear forwards';
        hTimer = setTimeout(function() { goHeroSlide(1); }, 3000);
      }, 100);
    }
  } catch(e) { console.warn('Hero crossfader error:', e); }
})();

// Waste calculator
function rangeLabel(val) {
  if (val === 0) return 'Never';
  const w = val;
  if (w < 7) return `${w}× / week`;
  if (w === 7) return 'Once a day';
  if (w < 14) return `${Math.round(w/7*10)/10}× / day`;
  return `${Math.round(w/7*10)/10}× / day`;
}

function calcWaste() {
  if (!document.getElementById('r1')) return;
  const r1 = +document.getElementById('r1').value;
  const r2 = +document.getElementById('r2').value;
  const r3 = +document.getElementById('r3').value;
  const r4 = +document.getElementById('r4').value;

  document.getElementById('r1val').textContent = rangeLabel(r1);
  document.getElementById('r2val').textContent = rangeLabel(r2);
  document.getElementById('r3val').textContent = rangeLabel(r3);
  document.getElementById('r4val').textContent = rangeLabel(r4);

  const cups = Math.round(r1 * 52);
  const bottles = Math.round(r2 * 52);
  const utensils = Math.round(r3 * 52);
  const plates = Math.round(r4 * 52);
  const total = cups + bottles + utensils + plates;
  const lbs = Math.round(total * 0.0236 * 10) / 10;

  document.getElementById('res-cups').textContent = cups.toLocaleString();
  document.getElementById('res-bottles').textContent = bottles.toLocaleString();
  document.getElementById('res-utensils').textContent = utensils.toLocaleString();
  document.getElementById('res-plates').textContent = plates.toLocaleString();
  document.getElementById('res-total').textContent = total.toLocaleString();
  document.getElementById('res-lbs').textContent = lbs + ' lbs';
  document.getElementById('res-total-inline').textContent = total.toLocaleString();
}
calcWaste();

// ── Total Impact System ──
let currentUser = null;

async function submitImpact() {
  const fn = document.getElementById('firstName').value.trim();
  const ln = document.getElementById('lastName').value.trim();
  const email = document.getElementById('emailField').value.trim();
  const username = document.getElementById('usernameField').value.trim();
  const zipCode = document.getElementById('zipField').value.trim();
  const password = document.getElementById('passwordField').value;
  const status = document.getElementById('join-status');
  const btn = document.getElementById('joinBtn');

  if (!fn || !ln || !email || !username || !zipCode || !password) {
    status.style.display = 'block';
    status.style.background = 'rgba(255,80,80,0.15)';
    status.style.color = '#ff6b6b';
    status.textContent = 'Please fill in all fields.';
    return;
  }
  if (password.length < 8) {
    status.style.display = 'block';
    status.style.background = 'rgba(255,80,80,0.15)';
    status.style.color = '#ff6b6b';
    status.textContent = 'Password must be at least 8 characters.';
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Creating your page...';

  // Check for referrer in URL params
  const urlParams = new URLSearchParams(window.location.search);
  const referrer = urlParams.get('ref') || '';

  try {
    const res = await fetch('/api/signup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, firstName: fn, lastName: ln, password, username, zipCode, referredByUsername: referrer }),
    });
    const data = await res.json();

    if (res.ok) {
      status.style.display = 'block';
      status.style.background = 'rgba(76,175,80,0.15)';
      status.style.color = '#4caf50';

      if (data.alreadyExists) {
        status.innerHTML = "You're already signed up! Loading your dashboard...";
        sessionStorage.setItem('tb_email', email);
        setTimeout(() => loadDashboard(email), 1000);
      } else {
        const profileUrl = data.user.profileUrl;
        status.innerHTML = `Welcome! Your page is live at <strong>totalbottle.com${profileUrl}</strong> — Share it to earn points!`;
        sessionStorage.setItem('tb_email', email);
        setTimeout(() => loadDashboard(email), 2000);
      }
    } else {
      status.style.display = 'block';
      status.style.background = 'rgba(255,80,80,0.15)';
      status.style.color = '#ff6b6b';
      status.textContent = data.error || 'Something went wrong.';
    }
  } catch (err) {
    status.style.display = 'block';
    status.style.background = 'rgba(255,80,80,0.15)';
    status.style.color = '#ff6b6b';
    status.textContent = 'Network error. Please try again.';
  }
  btn.disabled = false;
  btn.textContent = 'Join Total Impact →';
}

function showLoginPrompt() {
  // Create login modal overlay
  const existing = document.getElementById('login-modal');
  if (existing) { existing.style.display = 'flex'; return; }

  const modal = document.createElement('div');
  modal.id = 'login-modal';
  modal.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.7);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)';

  modal.innerHTML = `
    <div style="background:var(--card-bg);border:1px solid rgba(255,255,255,0.08);border-radius:16px;padding:40px;max-width:400px;width:90%;position:relative">
      <button onclick="document.getElementById('login-modal').style.display='none'" style="position:absolute;top:16px;right:16px;background:none;border:none;color:rgba(255,255,255,0.4);font-size:20px;cursor:pointer;padding:4px 8px">&times;</button>
      <h2 style="font-family:var(--font-display);font-size:22px;color:white;margin:0 0 8px">Welcome Back</h2>
      <p style="font-size:14px;color:rgba(255,255,255,0.5);margin:0 0 24px">Log in to view your dashboard and referral stats.</p>
      <div id="login-error" style="display:none;padding:10px;border-radius:8px;background:rgba(255,59,48,0.1);border:1px solid rgba(255,59,48,0.2);color:#ff6b6b;font-size:13px;margin-bottom:16px;text-align:center"></div>
      <label style="font-size:12px;color:rgba(255,255,255,0.5);letter-spacing:0.5px;text-transform:uppercase;display:block;margin-bottom:6px">Email Address</label>
      <input id="login-email" type="email" placeholder="you@email.com" style="width:100%;padding:12px 16px;border-radius:8px;border:1px solid rgba(255,255,255,0.1);background:rgba(255,255,255,0.04);color:white;font-size:14px;font-family:var(--font-body);outline:none;box-sizing:border-box;margin-bottom:12px">
      <label style="font-size:12px;color:rgba(255,255,255,0.5);letter-spacing:0.5px;text-transform:uppercase;display:block;margin-bottom:6px">Password</label>
      <input id="login-password" type="password" placeholder="Your password" style="width:100%;padding:12px 16px;border-radius:8px;border:1px solid rgba(255,255,255,0.1);background:rgba(255,255,255,0.04);color:white;font-size:14px;font-family:var(--font-body);outline:none;box-sizing:border-box;margin-bottom:24px">
      <button id="login-submit-btn" onclick="handleLogin()" style="width:100%;padding:12px;border-radius:8px;border:none;background:var(--blue);color:white;font-family:var(--font-body);font-size:14px;font-weight:600;cursor:pointer;transition:all 0.2s;letter-spacing:0.3px">Log In</button>
      <p style="text-align:center;margin:16px 0 0;font-size:13px;color:rgba(255,255,255,0.4)">Don't have an account? <a href="#impact" onclick="document.getElementById('login-modal').style.display='none'" style="color:var(--green);text-decoration:none">Sign up free →</a></p>
    </div>
  `;

  // Close on backdrop click
  modal.addEventListener('click', (e) => { if (e.target === modal) modal.style.display = 'none'; });

  document.body.appendChild(modal);

  // Enter key support
  modal.querySelector('#login-email').addEventListener('keydown', (e) => { if (e.key === 'Enter') modal.querySelector('#login-password').focus(); });
  modal.querySelector('#login-password').addEventListener('keydown', (e) => { if (e.key === 'Enter') handleLogin(); });

  setTimeout(() => modal.querySelector('#login-email').focus(), 100);
}

async function handleLogin() {
  const email = document.getElementById('login-email').value.trim();
  const password = document.getElementById('login-password').value;
  const errEl = document.getElementById('login-error');
  const btn = document.getElementById('login-submit-btn');

  if (!email) { errEl.textContent = 'Please enter your email.'; errEl.style.display = 'block'; return; }

  btn.textContent = 'Logging in...'; btn.disabled = true;
  errEl.style.display = 'none';

  try {
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) {
      const err = await res.json();
      errEl.textContent = err.error || 'Invalid email or password.';
      errEl.style.display = 'block';
      btn.textContent = 'Log In'; btn.disabled = false;
      return;
    }
    const data = await res.json();
    currentUser = data;
    sessionStorage.setItem('tb_email', email);
    renderDashboard(data);
    document.getElementById('login-modal').style.display = 'none';
    showTab('dashboard');
  } catch (err) {
    errEl.textContent = 'Something went wrong. Please try again.';
    errEl.style.display = 'block';
    btn.textContent = 'Log In'; btn.disabled = false;
  }
}

async function loadDashboard(email) {
  try {
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (!res.ok) {
      const err = await res.json();
      alert(err.error || 'User not found.');
      return;
    }
    const data = await res.json();
    currentUser = data;
    sessionStorage.setItem('tb_email', email);
    renderDashboard(data);
    showTab('dashboard');
  } catch (err) {
    alert('Could not load dashboard. Please try again.');
  }
}

function renderDashboard(data) {
  const u = data.user;
  document.getElementById('d-avatar').textContent = u.firstName[0].toUpperCase();
  if (u.avatarUrl) {
    const avatarEl = document.getElementById('d-avatar');
    let img = avatarEl.querySelector('img');
    if (!img) { img = document.createElement('img'); img.style.cssText='width:100%;height:100%;object-fit:cover;position:absolute;inset:0;border-radius:50%'; avatarEl.style.position='relative'; avatarEl.style.overflow='hidden'; avatarEl.appendChild(img); }
    img.src = u.avatarUrl;
  }
  document.getElementById('d-name').textContent = `${u.firstName} ${u.lastName[0]}.`;
  document.getElementById('d-email').textContent = u.email;
  document.getElementById('d-link').value = `totalbottle.com/u/${u.username}`;
  document.getElementById('d-profile-link').href = `/u/${u.username}`;

  // Impact Stats
  const is = data.impactStats || {};
  document.getElementById('d-signups').textContent = is.raffleSignups || 0;
  document.getElementById('d-bottles').textContent = is.bottlesSold || 0;
  document.getElementById('d-donations').textContent = is.donationPoints || 0;
  document.getElementById('d-cascade').textContent = is.cascadePoints || 0;
  document.getElementById('d-total-impact').textContent = is.totalImpact || 0;

  // Referrals table
  const rbody = document.getElementById('ref-body');
  if (data.referrals.length === 0) {
    rbody.innerHTML = '<tr><td colspan="2" style="text-align:center;color:rgba(255,255,255,0.3);padding:24px">No referrals yet. Share your link to get started!</td></tr>';
  } else {
    rbody.innerHTML = data.referrals.map(r =>
      `<tr><td>${r.name}</td><td>${new Date(r.date).toLocaleDateString()}</td></tr>`
    ).join('');
  }

  // Events table
  const ebody = document.getElementById('evt-body');
  if (data.events.length === 0) {
    ebody.innerHTML = '<tr><td colspan="3" style="text-align:center;color:rgba(255,255,255,0.3);padding:24px">No point events yet.</td></tr>';
  } else {
    const typeLabels = { signup_referral: 'Signup', purchase_referral: 'Purchase', donation_referral: 'Donation' };
    ebody.innerHTML = data.events.map(e =>
      `<tr><td>${typeLabels[e.event_type] || e.event_type}</td><td style="color:var(--green)">+${e.points}</td><td>${new Date(e.created_at).toLocaleDateString()}</td></tr>`
    ).join('');
  }

  // Show dashboard nav items, hide login
  document.getElementById('nav-dashboard').style.display = '';
  document.getElementById('nav-dash-btn').style.display = '';
  document.getElementById('nav-login-btn').style.display = 'none';
}

function showTab(tab) {
  const mainContent = document.getElementById('main-site');
  const dashContent = document.getElementById('dashboard-tab');
  if (tab === 'dashboard') {
    mainContent.style.display = 'none';
    dashContent.style.display = 'block';
    window.scrollTo(0, 0);
  } else {
    mainContent.style.display = '';
    dashContent.style.display = 'none';
  }
}

function copyLink() {
  const input = document.getElementById('d-link');
  navigator.clipboard.writeText('https://' + input.value);
  const btn = input.parentElement.querySelector('button');
  btn.textContent = 'Copied!';
  setTimeout(() => btn.textContent = 'Copy', 2000);
}

function dashLogout() {
  sessionStorage.removeItem('tb_email');
  currentUser = null;
  document.getElementById('nav-dashboard').style.display = 'none';
  document.getElementById('nav-dash-btn').style.display = 'none';
  document.getElementById('nav-login-btn').style.display = '';
  showTab('main');
}

// Auto-login if session exists
(function() {
  const stored = sessionStorage.getItem('tb_email');
  if (stored) loadDashboard(stored);
})();

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
reveals.forEach(r => observer.observe(r));

// Nav scroll style
var navEl = document.getElementById('nav');
if (navEl) {
  window.addEventListener('scroll', function() {
    navEl.classList.toggle('scrolled', window.scrollY > 60);
  });
}
